/**
 * @generated SignedSource<<e3de5f1ccb73e57936b458a16b6452e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubLessonStageModelLessonTypeChoices = "GROUP" | "INDIVIDUAL" | "PAIRED" | "%future added value";
export type CreateLessonStageInput = {
  block: number;
  clientMutationId?: string | null | undefined;
  costPerLesson: number;
  lessonDuration: number;
  lessonType: string;
  schoolId: string;
  stage?: number | null | undefined;
  startingYear: number;
};
export type CreateLessonStageMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateLessonStageInput;
};
export type CreateLessonStageMutation$data = {
  readonly createLessonStage: {
    readonly errors: any | null | undefined;
    readonly lessonStage: {
      readonly costPerLesson: number | null | undefined;
      readonly id: string;
      readonly lessonDuration: number | null | undefined;
      readonly lessonType: PianofunclubLessonStageModelLessonTypeChoices;
      readonly stage: number | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type CreateLessonStageMutation = {
  response: CreateLessonStageMutation$data;
  variables: CreateLessonStageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonStageNode",
  "kind": "LinkedField",
  "name": "lessonStage",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lessonDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lessonType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "costPerLesson",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateLessonStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateLessonStagePayload",
        "kind": "LinkedField",
        "name": "createLessonStage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateLessonStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateLessonStagePayload",
        "kind": "LinkedField",
        "name": "createLessonStage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "lessonStage",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "LessonStageNodeEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f7f7f4faeb07fd2355e9cb690e010bb7",
    "id": null,
    "metadata": {},
    "name": "CreateLessonStageMutation",
    "operationKind": "mutation",
    "text": "mutation CreateLessonStageMutation(\n  $input: CreateLessonStageInput!\n) {\n  createLessonStage(input: $input) {\n    success\n    errors\n    lessonStage {\n      id\n      stage\n      lessonDuration\n      lessonType\n      costPerLesson\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0757b56687e3e1f40b9a66f081a94669";

export default node;
